import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Button,
  Box,
  Stack,
} from "@mui/material";
import TokenStorage from "../../../shared/components/token";
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;

function LoginDialog({ open, onClose }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Lütfen e-posta ve şifre alanlarını doldurunuz!");
      return;
    }
  
    try {
      const response = await axios.post(`${apiUrl}/login`, {
        data: { username: email, password: password },
      });
  
      console.log("Login successful:", response.data);
      TokenStorage.setToken(response.data.token); // Token'ı sakla
      alert("Giriş başarılı!");
      onClose(); // Dialog'u kapat
      window.location.href = "/c"; // Yönlendirme
    } catch (error) {
      console.error("Login failed:", error);
      alert("Virheellinen Salasana tai Käyttäjätunnus"); // Hata mesajı
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Kirjaudu</DialogTitle>
      <DialogContent>
        <Stack  direction='column' spacing={5}>
        <DialogContentText>
        Anna sähköpostiosoitteesi ja salasanasi kirjautuaksesi sisään.
        </DialogContentText>
      
          <TextField
            autoFocus
            margin="dense"
            id="email"
            label="Sähköposti"
            type="email"
            fullWidth
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="dense"
            id="password"
            label="Salasana"
            type="password"
            fullWidth
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        
        </Stack>
      </DialogContent>
      <DialogActions  >
        <Box width='100%'  display='flex' justifyContent='space-between'>
        <Button  onClick={onClose} color="error">
          İptal
        </Button>
        <Button onClick={handleLogin} color="success">
          Giriş Yap
        </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

export default LoginDialog;
